import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
  AiOutlineHistory,
} from "react-icons/ai";
import { CgFileDocument, CgPokemon } from "react-icons/cg";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);
  const [showAdminTabs, setShowAdminTabs] = useState(false);

  useEffect(() => {
    // On component mount, check localStorage
    const IsLogged = localStorage.getItem("IsLogged");
    if (IsLogged === "True") {
      setShowAdminTabs(true);
    }
  }, []);

  useEffect(() => {
    function scrollHandler() {
      if (window.scrollY >= 20) {
        updateNavbar(true);
      } else {
        updateNavbar(false);
      }
    }

    window.addEventListener("scroll", scrollHandler);
    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          {/* <img src={logo} className="img-fluid logo" alt="brand" /> */}
        <h4 className="logo">kkk.</h4>        
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => updateExpanded(expand ? false : "expanded")}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>
                <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
              </Nav.Link>
            </Nav.Item>

            {!showAdminTabs && (
              <>
                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    to="/about"
                    onClick={() => updateExpanded(false)}
                  >
                    <AiOutlineUser style={{ marginBottom: "2px" }} /> About
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    to="/project"
                    onClick={() => updateExpanded(false)}
                  >
                    <AiOutlineFundProjectionScreen
                      style={{ marginBottom: "2px" }}
                    />{" "}
                    Projects
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    to="/Experaince"
                    onClick={() => updateExpanded(false)}
                  >
                    <AiOutlineHistory style={{ marginBottom: "2px" }} />{" "}
                    Experience
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    to="/resume"
                    onClick={() => updateExpanded(false)}
                  >
                    <CgFileDocument style={{ marginBottom: "2px" }} /> Resume
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    to="/Certificates"
                    onClick={() => updateExpanded(false)}
                  >
                    <CgPokemon style={{ marginBottom: "2px" }} />{" "}
                    Blogs
                  </Nav.Link>
                </Nav.Item>
              </>
            )}

            {showAdminTabs && (
              <>
                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    to="/admin/addprject"
                    onClick={() => updateExpanded(false)}
                  >
                    <CgFileDocument style={{ marginBottom: "2px" }} /> Add
                    Project
                  </Nav.Link>
                </Nav.Item>
{/* 
                <Nav.Item>
                  <Nav.Link
                    as={Link}
                    to="/admin/handleproject"
                    onClick={() => updateExpanded(false)}
                  >
                    <CgFileDocument style={{ marginBottom: "2px" }} /> Manage
                    Projects
                  </Nav.Link>
                </Nav.Item> */}
                 <Nav.Item>
                <Nav.Link
                    as={Link}
                    to="/admin/addAchivement"
                    onClick={() => {updateExpanded(false)}}
                  >
                    <CgFileDocument style={{ marginBottom: "2px" }} /> 
                    Add Blog
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                <Nav.Link
                    as={Link}
                    to="/admin"
                    onClick={() => {localStorage.removeItem("IsLogged"); setShowAdminTabs(false);updateExpanded(false);localStorage.removeItem("Token")}}
                  >
                    <CgFileDocument style={{ marginBottom: "2px" }} /> 
                    LogOut
                    </Nav.Link>
                </Nav.Item>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
